/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Status of the product
 */
export const ProductStatus = {
  Active: "active",
  Archived: "archived",
} as const;
/**
 * Status of the product
 */
export type ProductStatus = ClosedEnum<typeof ProductStatus>;

/** @internal */
export const ProductStatus$inboundSchema: z.ZodNativeEnum<
  typeof ProductStatus
> = z.nativeEnum(ProductStatus);
/** @internal */
export const ProductStatus$outboundSchema: z.ZodNativeEnum<
  typeof ProductStatus
> = ProductStatus$inboundSchema;
